module.exports = __webpack_public_path__ + "static/media/pokeball.5ac0f4d9.gif";